module.exports = __webpack_public_path__ + "img/1252311130.b0f6951a.jpg";